import { Gap, Grid, Heading, Panel, theme } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import { ConsentFileType } from '../types';
import { DropArea } from './DropArea';
import { useImportConsentContext } from '../context/ImportConsentContext';

export function DropFilesArea() {
  const { clientId } = useImportConsentContext();
  const { t } = useTranslation('fileManagement');

  if (!clientId) {
    return null;
  }

  return (
    <>
      <Gap top={50} />
      <Panel variation="clean" padding={0}>
        <Heading variation="h2" color={theme.vars.color.grey4}>
          {t('analysis.dropFilesArea.heading')}
        </Heading>
        <Gap top={20} />
        <Grid
          columnMaxWidth={{ value: 333, unit: 'px' }}
          columnMinWidth={{ value: 333, unit: 'px' }}
          columnNumber={3}
          gridGap={40}
        >
          <DropArea fileType={ConsentFileType.OPT_IN} />
          <DropArea fileType={ConsentFileType.OPT_OUT} />
          <DropArea fileType={ConsentFileType.CONFIRMED_OPT_IN} />
        </Grid>
      </Panel>
    </>
  );
}
